<header class="box noshrink flex align-center justify-space-between gap-1">
  <h2 class="h5 weight-bold text-900 m-0">{{ 'bidChat.ChatLogs' | translate }}</h2>
  <button mat-icon-button type="button" class="box noshrink" [attr.aria-label]="'bidChat.Close' | translate" (click)="closed.emit()">
    <app-icon name="outline-cross" size="xxs" class="text-600"></app-icon>
  </button>
</header>

<app-search-input
  class="box noshrink"
  [placeholder]="'bidChat.Search' | translate"
  [showSearchActions]="false"
  (searchValue)="onSearch($event)"
></app-search-input>

<app-tab
  class="chat-logs__tabs box noshrink"
  theme="underline"
  [tabs]="tabs"
  [stretchTabs]="true"
  [selectedIndex]="selectedTab"
  (currentIndex)="onTabChange($event)"
></app-tab>

<!-- Each tab waits only for its own source: Active for Firestore, History for the REST call. -->
<div class="chat-logs__shrinkable box grow scrollable--y flex column" *ngIf="logs$ | async as logs">
  <ng-container *ngIf="selectedTab === chatLogsTab.Active">
    <ng-container *ngIf="logs.hasActiveSnapshot; else skeleton">
      <ng-container *ngIf="logs.active.length; else noActive">
        <ng-container *ngFor="let row of logs.active; trackBy: trackByConversation">
          <ng-container *ngTemplateOutlet="conversationRow; context: { $implicit: row }"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="selectedTab === chatLogsTab.History">
    <ng-container *ngIf="logs.hasClosedSnapshot; else skeleton">
      <ng-container *ngIf="logs.closed.length; else noHistory">
        <ng-container *ngFor="let row of logs.closed; trackBy: trackByConversation">
          <ng-container *ngTemplateOutlet="conversationRow; context: { $implicit: row }"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #conversationRow let-row>
  <button
    type="button"
    class="chat-logs__row flex align-flex-start gap-3 w-100 py-3 px-0 cursor-pointer text-left"
    (click)="rowSelected.emit(row)"
  >
    <span
      class="box noshrink flex align-center justify-center p-2 radius-2"
      [ngClass]="row.status !== openStatus ? 'bg-100 text-400' : row.unreadCount ? 'bg-secondry-light text-secondry' : 'bg-primary-lighter text-primary'"
    >
      <app-icon name="outline-box" size="xs"></app-icon>
    </span>

    <span class="chat-logs__shrinkable box grow flex column">
      <span class="small flex align-center gap-2 text-nowrap">
        <span *ngIf="row.shipmentId" [ngClass]="row.status !== openStatus ? 'text-600' : 'text-900'">#{{ row.shipmentId }}</span>
        <span *ngIf="row.fromCity && row.toCity" class="chat-logs__shrinkable flex align-center gap-1 weight-medium text-600">
          <span class="text-ellipsis">{{ row.fromCity }}</span>
          <app-icon name="outline-arrow-narrow-right" size="xxs" class="box noshrink text-400"></app-icon>
          <span class="text-ellipsis">{{ row.toCity }}</span>
        </span>
      </span>
      <span *ngIf="row.lastMessagePreview" class="chat-logs__preview small text-primary-200">
        {{ senderLabel(row) }}
        <ng-container *ngIf="offerPreviewPrice(row) as price; else textPreview">
          {{ 'bidChat.OfferPreview' | translate }} <span riyalCurrency>{{ price | number: '1.0-2' }}</span>
        </ng-container>
        <ng-template #textPreview>{{ row.lastMessagePreview }}</ng-template>
      </span>
      <span class="chat-logs__meta weight-medium text-primary-200 text-ellipsis text-nowrap">
        {{ rowTime(row) }}
      </span>
    </span>

    <!-- History rows never show a badge (contract §7.1). -->
    <span
      *ngIf="row.status === openStatus && row.unreadCount > 0"
      class="chat-logs__meta chat-logs__badge box noshrink flex align-center justify-center px-1 radius-4 bg-secondry text-white"
    >
      {{ unreadBadge(row) }}
    </span>
  </button>
</ng-template>

<ng-template #skeleton>
  <div *ngFor="let row of skeletonRows" class="flex align-center gap-3 py-3">
    <span class="chat-logs__skeleton-icon box noshrink radius-2 bg-100"></span>
    <span class="box grow flex column gap-2">
      <span class="chat-logs__skeleton-line radius-1 bg-100 w-50"></span>
      <span class="chat-logs__skeleton-line radius-1 bg-100 w-83"></span>
    </span>
  </div>
</ng-template>

<ng-template #noActive>
  <ng-container
    *ngTemplateOutlet="emptyState; context: { title: 'bidChat.NoActiveChats', description: 'bidChat.NoChatsYetDescription' }"
  ></ng-container>
</ng-template>

<ng-template #noHistory>
  <ng-container
    *ngTemplateOutlet="emptyState; context: { title: 'bidChat.NoChatHistory', description: 'bidChat.NoChatHistoryDescription' }"
  ></ng-container>
</ng-template>

<ng-template #emptyState let-title="title" let-description="description">
  <div class="box grow flex column align-center justify-center gap-3 text-center p-6">
    <span class="flex align-center justify-center p-3 radius-50 bg-accent-lighter">
      <app-icon name="twotone-messages" size="sm" class="text-accent"></app-icon>
    </span>
    <span class="flex column align-center gap-1">
      <span class="h6 m-0 weight-normal text-900">{{ title | translate }}</span>
      <span class="small text-600">{{ description | translate }}</span>
    </span>
  </div>
</ng-template>
